import type {CSSProperties} from "react";
import {token} from "@atlaskit/tokens";
import type {BadgeConfig} from "~/components/table/table.types";
import {getDefaultBadgeConfig} from "~/components/table/tableUtils.tsx";

export function Badge({value, config}: {value: string; config?: BadgeConfig}) {
    const resolved = config ?? getDefaultBadgeConfig(value);
    const style: CSSProperties =
        resolved.variant === "outline"
            ? {color: resolved.color, background: resolved.bgColor ?? "transparent", border: `1px solid ${resolved.color}`}
            : {color: token("color.icon.inverse"), background: resolved.color, border: "1px solid transparent"};

    return (
        <span className="table-badge" style={style}>
            {value}
        </span>
    );
}

export function TagList({
    values,
    badgeMap,
}: {
    values: string[]
    badgeMap?: Record<string, BadgeConfig>
}) {
    return (
        <div className="table-tag-list">
            {values.map((value, i) => (
                <Badge key={`${value}-${i}`} value={value} config={badgeMap?.[value]} />
            ))}
        </div>
    );
}
